var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canPokerAct || _vm.showPokerPassoHint
    ? _c(
        "div",
        { staticClass: "panoramica-actions" },
        [
          _vm.canPokerAct
            ? [
                _vm.migliore_offerta.vincitore
                  ? _c(
                      "v-btn",
                      {
                        attrs: { rounded: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.setRilancio(1)
                          },
                        },
                      },
                      [_vm._v("\n      +1\n    ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.migliore_offerta.vincitore && _vm.maxRilancio > 1
                  ? _c(
                      "v-btn",
                      {
                        attrs: { rounded: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.setRilancio(_vm.maxRilancio)
                          },
                        },
                      },
                      [_vm._v("\n      +" + _vm._s(_vm.maxRilancio) + "\n    ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.migliore_offerta.vincitore
                  ? _c(
                      "v-btn",
                      {
                        attrs: { rounded: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.setOffertaCustom(_vm.minOfferta)
                          },
                        },
                      },
                      [_vm._v("\n      " + _vm._s(_vm.minOfferta) + "\n    ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.maxOfferta > 1,
                        expression: "maxOfferta > 1",
                      },
                    ],
                    attrs: { rounded: "", color: "primary" },
                    on: { click: _vm.showNumpad },
                  },
                  [_vm._v("\n      ...\n    ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "text--text",
                    attrs: { rounded: "", color: "white" },
                    on: { click: _vm.setPasso },
                  },
                  [_vm._v("\n      Passo\n    ")]
                ),
              ]
            : _c("div", { staticClass: "panoramica-poker-hint" }, [
                _vm._v("\n    " + _vm._s(_vm.pokerPassoText) + "\n  "),
              ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }